import LinkTextInput from './LinkTextInput';
export default LinkTextInput;
